import { useAuth0 } from '@auth0/auth0-react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/keys';

export const useGetIdTokenClaims = () => {
  const { isAuthenticated, getIdTokenClaims, getAccessTokenSilently } =
    useAuth0();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [
      ...queryKeys.auth.getIdTokenClaims(isAuthenticated),
      queryClient,
      getIdTokenClaims,
      getAccessTokenSilently,
    ],
    queryFn: async ({ queryKey }) => {
      const queryState = queryClient.getQueryState(queryKey);
      if (queryState?.dataUpdateCount !== 0) {
        // NOTE: invalidating access token to make sure auth0 SDK sends a real XHR request
        // instead of relying on cache.
        // NOTE: dataUpdateCount indicates how many times this query has been "rerun"/"refetched",
        // which helps us determine if that's a fetch for invalidation which happens as a second query
        // or it's a first one
        await getAccessTokenSilently({ cacheMode: 'off' });
      }

      return (await getIdTokenClaims()) ?? null;
    },
    enabled: isAuthenticated,
    staleTime: 40_000,
    retry: false,
  });
};
